module.exports = __webpack_public_path__ + "img/subject_select.750408e1.svg";